import React from "react";
import topIcon from "../../Assets/Images/topIconImage.svg";

function LandingIcon() {
  return (
    <div id="landingIcon">
      <img src={topIcon} alt="" />
    </div>
  );
}

export default LandingIcon;
